module.exports = __webpack_public_path__ + "static/media/iotnet..403d5df3.jpeg";